import React, { useState } from "react";
import PropTypes from "prop-types";

import {
  Box,
  Button,
  Typography,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  Card,
} from "@material-ui/core";
import PdfPreferences from "./PdfPreferences";
import DownloadBar from "./DownloadBar";
import GetAppOutlinedIcon from "@material-ui/icons/GetAppOutlined";

export default function PdfDl(props) {
  const t = props.t;

  //get pages out of props
  const defaultLastPage = props.manifest.json.sequences[0].canvases.length;

  const [firstPage, setFirstPage] = useState(1);
  const [lastPage, setLastPage] = useState(defaultLastPage);
  const [progress, setProgress] = useState(0);
  const [disabled, setDisabled] = useState(false);
  const [pct, setPct] = useState(100);
  const [colorOpen, setColorOpen] = useState(false);
  const [color, setColor] = useState("default");
  const [open, setOpen] = useState(false);
  const [dlName, setDlName] = useState("");

  const handleFirstPage = (e) => {
    setFirstPage(e.target.value);
  };
  const handleLastPage = (e) => {
    setLastPage(e.target.value);
  };
  const handleQualityChange = (e) => {
    setPct(e.target.value);
  };
  const handleColorChange = (e) => {
    setColor(e.target.value);
  };
  const handleColorClose = () => {
    setColorOpen(false);
  };
  const handleColorOpen = () => {
    setColorOpen(true);
  };
  const handleOpen = () => {
    setOpen(true);
  };

  //sse
  const [eventSource, setEventSource] = useState();
  React.useEffect(() => {
    if (eventSource) {
      eventSource.onmessage = (e) => {
        const data = JSON.parse(e.data);
        if (typeof data["progress"] == "undefined") {
          setProgress(100);
          setDlName(data["dlink"]);
          setDisabled(true);
        } else {
          const prg = data.progress !== undefined && firstPage && lastPage && (lastPage - firstPage + 1 > 0) && (data.progress + 1) * 100 / (lastPage - firstPage + 1);
          setProgress(prg);
          setDlName(data["dlink"]);
          setDisabled(true);
        }
      };
      eventSource.onfinish = function () {
        eventSource.close();
      };
      eventSource.onerror = function () {
        eventSource.close();
      };
    }
  });

  //Button Back handleClose
  const handleClose = () => {
    setOpen(false);
    setDisabled(false);
    setProgress(0);
    setLastPage(defaultLastPage);
    if (eventSource) {
      eventSource.close();
    }
  };

  const endpoint = process.env.REACT_APP_ENDPOINT || '';

  //encode manifest + add manifest to endpoint
  const target =
    endpoint +
    "dl/pdf/?manifestUrl=" +
    encodeURIComponent(props["manifestUrl"]) +
    "&pages=" +
    firstPage +
    "&pages=" +
    lastPage +
    "&pct=" +
    pct +
    "&color=" +
    color;

  return (
    <Box fontWeight="fontWeightBold" mb={1} ml={1}>
      <Button
        variant="contained"
        startIcon={<GetAppOutlinedIcon fontSize="small" />}
        onClick={handleOpen}
      >
        {" "}
        PDF{" "}
      </Button>
      <Dialog fullWidth={false} maxWidth={'xs'} onClose={handleClose} open={open}>
        <DialogTitle className="pdfDialog" onClose={handleClose}>
          <Typography variant="h2">
            {t("downloadPdfMenu")}
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Typography fontWeight="fontWeightBold">{t("pdfText")} </Typography>
          <Card>
            {/* Preferences */}
            <PdfPreferences
              firstPage={firstPage}
              lastPage={lastPage}
              defaultFirstPage={1}
              defaultLastPage={defaultLastPage}
              handleFirstPage={handleFirstPage}
              handleLastPage={handleLastPage}
              t={t}
              handleQualityChange={handleQualityChange}
              quality={pct}
              colorOpen={colorOpen}
              handleColorOpen={handleColorOpen}
              handleColorClose={handleColorClose}
              color={color}
              handleColorChange={handleColorChange}
              disabled={disabled}
            />
          </Card>
          <br />
          <DownloadBar
            // lastSelectedPage={lastPage}
            endpoint={endpoint}
            target={target}
            progress={progress}
            t={t}
            disabled={disabled}
            setEventSource={setEventSource}
            dlName={dlName}
          />
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" onClick={handleClose}>
            {t("back")}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}

PdfDl.propTypes = {
  defaultLastPage: PropTypes.number,
  endpoint: PropTypes.string,
  target: PropTypes.string,
};